import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
		<Path d="M6 5V18.5911L12 13.8473L18 18.5911V5H6Z" />
	</SVG>
);
